export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (err) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.opacity = "0"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      return document.execCommand("copy")
    } catch (e) {
      console.error("Fallback copy failed:", e)
      return false
    } finally {
      document.body.removeChild(textArea)
    }
  }
}
